<!--
 * @Author: 田鑫
 * @Date: 2022-04-21 14:31:44
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-04-24 11:21:49
 * @Description:
-->
<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>统计管理</el-breadcrumb-item>
        <el-breadcrumb-item>调查问卷统计报表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form-container box-shadow">
      <div class="flex">
        <div class="item">
          <div class="label">问卷名称：</div>
          <div class="content">{{ formData.questionnaireName }}</div>
        </div>
        <div class="item">
          <div class="label">保障用户人数：</div>
          <div class="content">{{ formData.supplyUserCount }}人</div>
        </div>
        <div class="item">
          <div class="label">截止日期：</div>
          <div class="content">{{ formData.nowTime }}</div>
        </div>
        <div class="item">
          <div class="label">提交人数：</div>
          <div class="content">{{ formData.submitSupplyUserCount }}人</div>
        </div>
      </div>
    </div>

    <div class="form-container box-shadow">
      <div class="btn">
        <el-button @click="linkToAnotherPage" type="primary">查看建议反馈</el-button>
      </div>
      <div class="flex">
        <div class="chart-item" v-for="(item, index) in chartList" :key="index">
          <div class="title">{{ item.problemName }}</div>
          <div class="chart">
            <div class="left">
              <div class="label">答题人数（人）</div>
              <div class="content">{{ item.submitSupplyUserCount }}</div>
            </div>
            <div class="right">
              <PieChart :data="formatChartData(item.proportion)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from "./Pie";
export default {
  data() {
    return {
      formData: {
        questionnaireName: "",
        supplyUserCount: "",
        nowTime: "",
        submitSupplyUserCount: "",
      },
      chartList: [],
      chartData: [],
    };
  },
  components: { PieChart },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.loadChartData();
  },
  //生命周期 - 方法
  methods: {
    loadChartData() {
      this.$http({
        url: global.apiUrl + "/questionnaire/chart",
        methods: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            let data = res.body.data;
            this.formData.questionnaireName = data.questionnaireName;
            this.formData.supplyUserCount = data.supplyUserCount;
            this.formData.nowTime = data.nowTime;
            this.formData.submitSupplyUserCount = data.submitSupplyUserCount;
            this.chartList = data.problemScoreArray;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    formatChartData(data) {
      return data.map(item => {
        return item.value;
      });
    },
    linkToAnotherPage() {
      this.$router.push({
        name: "surveyFeedback",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-container {
  padding: 20px 20px 10px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  .flex {
    width: 100%;
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    font-size: 16px;
    .item {
      flex: 0 0 33%;
      display: flex;
      margin-bottom: 10px;
    }
    .chart-item {
      flex: 0 0 30%;
      margin: 20px;
      .title {
        font-size: 16px;
        color: #777777;
        font-weight: 500;
        margin-bottom: 10px;
      }
      .chart {
        display: flex;
        align-items: center;
        background-color: #fff;
        padding: 10px;
        border-radius: 12px;
        .left {
          text-align: center;
          flex: 1;
          .label {
            color: #777777;
            font-weight: 700;
          }
          .content {
            margin-top: 10px;
            color: orange;
            font-weight: 500;
          }
        }
        .right {
          flex: 1;
        }
      }
    }
    .label {
      color: #777777;
      font-weight: 700;
    }
    .content {
      color: orange;
      font-weight: 500;
    }
  }
}
</style>
